import { Base64 } from 'js-base64';
import _pick from 'lodash/pick';
import _get from 'lodash/get';

// eslint-disable-next-line consistent-return
const decode = (base64Location) => {
  try {
    const decodedLocation = Base64.decode(base64Location);

    return JSON.parse(decodedLocation);
  } catch (error) {
    console.log('Error while decoding base64 string: ', error);
  }
};

const getLocationKey = (location) => {
  if (!location) {
    return undefined;
  }

  return _get(decode(location), 'key');
};

export default (query) => {
  const params = _pick(query, [
    'pDate',
    'dDate',
    'pTime',
    'dTime',
    'age',
    'lang',
    'currency',
    'resellerId',
    'isTest',
  ]);

  params.isTest = Boolean(params.isTest);

  const pKey = getLocationKey(query.pLocation);
  const dKey = getLocationKey(query.dLocation);

  return {
    ...params,
    pKey,
    dKey,
  };
};
